import React, { useEffect, useState } from "react";
import PageHeader from "@/components/PageHeader";
import api from "@/api/client";
import { Card } from "@/components/ui/card";
import { Building2, Users2, HardDrive, Layers3 } from "lucide-react";

const Stat = ({ label, value, icon: Icon, tone = "primary" }) => (
    <Card className="p-5">
        <div className="flex items-start justify-between">
            <div>
                <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">
                    {label}
                </div>
                <div className="kpi-value text-3xl mt-2 text-slate-900">{value}</div>
            </div>
            <div className={`h-9 w-9 rounded-lg grid place-items-center bg-blue-50 border border-blue-100 text-primary`}>
                <Icon size={17} />
            </div>
        </div>
    </Card>
);

export default function PlatformAnalytics() {
    const [d, setD] = useState(null);
    useEffect(() => { api.get("/platform/analytics").then((r) => setD(r.data)); }, []);
    if (!d) return <div className="text-slate-500 text-sm">Loading…</div>;
    return (
        <div className="space-y-6" data-testid="platform-analytics">
            <PageHeader
                title="Platform analytics"
                subtitle="Aggregated tenant metadata. No firm data is exposed."
            />
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                <Stat label="Total firms" value={d.firms.total} icon={Building2} />
                <Stat label="Active" value={d.firms.active} icon={Building2} />
                <Stat label="Pending approval" value={d.firms.pending} icon={Building2} />
                <Stat label="Users" value={d.users} icon={Users2} />
                <Stat label="Suspended" value={d.firms.suspended} icon={Layers3} />
                <Stat label="Rejected" value={d.firms.rejected} icon={Layers3} />
                <Stat
                    label="Storage used"
                    value={`${(d.storage_bytes / 1024 / 1024).toFixed(1)} MB`}
                    icon={HardDrive}
                />
            </div>
            <Card className="p-6">
                <h3 className="font-display text-lg font-semibold">Firms by plan</h3>
                <div className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-3">
                    {Object.entries(d.plans).map(([p, n]) => (
                        <div key={p} className="border rounded-md p-3">
                            <div className="text-[11px] uppercase tracking-widest text-slate-500">{p}</div>
                            <div className="kpi-value text-2xl text-slate-900">{n}</div>
                        </div>
                    ))}
                </div>
            </Card>
        </div>
    );
}
